import React, { useState, useEffect, lazy } from "react"
import _get from "lodash/get"
import Sticky from "react-sticky-el"
import { scroller } from "react-scroll"
import { isMobile } from "react-device-detect"

import StickyHeader from "../StickyHeader"
import ProductSelectYourStyle from "../SelectYourStyle/v1/SelectYourStyle"
import Toaster from "@/components/core/Toaster/Toaster"
import PDPTrimCalculator from "../TrimCalculator/TrimCalculator"
import PdpGroutChart from "./PdpGroutChart"

import { addDataLayer } from "./analytics"
import { SAMPLE } from "@/constants/index"
import {
  calculateCartData,
  getCartItemType,
  getCurrentSkuCouponDiscounts,
  getShortenedUrlwithGeneral,
  getUserAnalyticsObject,
  isShowAnalyticsEventLoaded,
  pdpTypeFormat,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import ProductSummary from "../ProductSummary"
import { setProductInfo } from "@/store/features/pdpSlice"
import { useDispatch } from "react-redux"
import ProductGalleryView from "../ProductGalleryView"
import AddToCart from "./AddToCart"

const ProductDetailView = props => {
  let str = props?.customLabel?.pagePath
    ? props.customLabel.pagePath.split("/")
    : ""
  let enablePresets = props?.customLabel?.enablepresets
    ? props.customLabel.enablepresets
    : ""
  let leadTimeRange = props?.productSummaryDetails?.LeadTimeRange_s || "";
  let strType = str ? str.pop() : ""
  const [templateType, setTemplateType] = useState("")
  const [showTrimCal, setshowTrimCal] = useState(false)
  const [showGroutModal, setShowGroutModal] = useState(false)
  const [priceTag, setPriceTag] = useState("")
  const [isGlobalPromotionPrice, setGlobalPromotionPrice] = useState(false)
  const [stickyHeightCalc, setStickyHeightCalc] = useState(0)
  const [onChangeStockAlert, setOnChangeStockAlert] = useState({
    show: false,
    mssg: "",
  })

  const { pdpData, config, RegionUOM = ""} = props
  const pdpDetails = pdpData ?? {}
  const { pdpProductCustomerFacingName, pdpDesktopImage } = pdpDetails

  const { general = {}, plpServletPath = "" } = config
  const { scene7AccountName: accountName = "" } = general
  const NO_FINISH_TYPE = "noFinishType"

  let imagesData = []
  imagesData = props.imagesData

  if (imagesData.length === 0 && pdpDesktopImage) {
    imagesData[0] = {
      label: " ",
      template: "LandscapeCategory",
      url: pdpDesktopImage,
    }
  }

  const dispatch = useDispatch()

  const openGroutChartModal = () => {
    !showGroutModal
      ? addDataLayer({
        title: "how much grout do i need",
        productInfo: JSON.stringify(productInfo),
      })
      : addDataLayer({
        title: `close`,
        productInfo: JSON.stringify(productInfo),
        isrecomendedProps: {
          isrecomended: true,
          type: `how much grout do i need modal`,
        },
      })
    setShowGroutModal(!showGroutModal)
  }

  const setRegionUOM = (RegionUOMVal) => {
    switch (RegionUOMVal) {
      case "ft2":
      case "FT2":
        setPriceTag(props.staticTexts?.perSF);
        setshowTrimCal(true);
        break;
      case "ft":
      case "FT":
        setPriceTag(props.staticTexts.perLF);
        setshowTrimCal(true);
        break;
      case "ea":
      case "EA":
        setPriceTag(props.staticTexts.perEach);
        setshowTrimCal(true);
        break;
      default:
        setPriceTag("");
        setshowTrimCal(false)
        break;
    }
  }

  const getTempType = () => {
    switch (strType) {
      case "tile-details":
        setTemplateType("tile")
        break
      case "trim-details":
        setTemplateType("trim")
        break
      case "grout-details":
        setTemplateType("grout")
        break
      case "lighting-details":
        setTemplateType("lighting")
        break
      case "samples-details":
        setTemplateType("samples")
        break
      case "bathroom-accessories":
        setTemplateType("accessories")
        break
    
    }
  }

  const [sticky, setSticky] = useState(false)
  const [navData, setNavData] = useState([])
  const [currentQuantity, setCurrentQuantity] = useState(1)
  const [imageColorDetails, setImageColorDetails] = useState("")

  const convertToText = id => {
    const parts = id.replace(/#/g, "").toLowerCase().split("-")
    parts.forEach(
      (word, i) => (parts[i] = word.charAt(0).toUpperCase() + word.substring(1))
    )
    return parts.join(" ")
  }

  useEffect(() => {
    getTempType()
    setTimeout(() => {
      let totalBlockList = [
        "product-main-overview",
        "product-details-tab-details",
        "pdp-as-grout-template",
        "pdp-as-tile-template",
        "pdp-as-trim-template",
        "pdp-you-may-like-it",
      ]
      const elements = [{ id: "#Overview" }, { id: "#Details" }]
      let navDataSet = []
      let finalId = ""
      elements.forEach((item, i) => {
        let itemId = convertToText(item.id)
        if (itemId) {
          for (let j = 0; j < totalBlockList.length; j++) {
            let splitItemsId = itemId ? itemId.split(" ") : ""
            if (splitItemsId) {
              for (let counter = 0; counter < splitItemsId.length; counter++) {
                if (
                  totalBlockList[j]
                    .toLowerCase()
                    .includes(splitItemsId[counter].toLowerCase()) &&
                  finalId == ""
                ) {
                  finalId = totalBlockList[j]
                  break
                }
              }
            }
          }
          let countData =
            finalId && finalId.match(/overview/gi) !== null
              ? 1
              : document.getElementById(finalId) &&
                document.getElementById(finalId) !== null
                ? Number(document.getElementById(finalId).getAttribute("total"))
                : ""
          if (countData > 0) {
            navDataSet.push({
              label: itemId,
              elemId: item.id,
              isActive: i === 0 ? true : false,
            })
          }
          finalId = ""
        }
      })
      setNavData(navDataSet)
    }, 5000)
  }, [])

  useEffect(() => {
    setRegionUOM(RegionUOM.toLowerCase());
  }, [RegionUOM])

  let comparedProductsCount = Number(_get(props, "comparedProductsCount", 0))
  const plpPagePath = getShortenedUrlwithGeneral(
    general.plpPagePath ?? "/",
    general
  )
  const serviceLandingPath = getShortenedUrlwithGeneral(
    general.servicePartsLandingPath ?? "/",
    general
  )
  const homePagePath = getShortenedUrlwithGeneral(
    general.homepageUrl ?? "/",
    general
  )
  const enableaddtocart = props?.customLabel?.enableaddtocart
  const {
    disableEcommerce,
    replaceAddToCart,
    replaceAddToCartCtaLabel,
    replaceAddToCartCtaLink,
    linkNewTab,
  } = props.authorData

  const enablecalculator = props?.customLabel?.enablecalculator
  const enableselectstyle = props?.customLabel?.enableselectstyle
  let plpUrl
  if (props.productCategoryType && plpServletPath) {
    const path = plpServletPath.find(i =>
      i.categories.includes(props.productCategoryType)
    )
    if (path) {
      if (
        general.shortendPagePath === null ||
        general.shortendPagePath === ""
      ) {
        plpUrl = `${path.url}.html`
      } else {
        const shortendPath = path.url.replace(general.shortendPagePath, "")
        plpUrl = `${shortendPath}`
      }
    } else {
      if (
        general.shortendPagePath === null ||
        general.shortendPagePath === ""
      ) {
        plpUrl = `${plpPagePath}/${props.productCategory
          .replace(/ +/g, "-")
          .toLowerCase()}.html`
      } else {
        plpUrl = `${plpPagePath}/${props.productCategory
          .replace(/ +/g, "-")
          .toLowerCase()}`
      }
    }
  } else {
    plpUrl =
      general.shortendPagePath === null || general.shortendPagePath === ""
        ? `${serviceLandingPath}.html`
        : `${serviceLandingPath}`
  }
  const discontinuedColor = Boolean(
    _get(
      props.colorsData?.find(item => item.id === props.sku),
      "discontinuedColor",
      ""
    )
  )
  let isDiscontinued = false
  let isColorDiscontinued = false
  if (props.discontinuedProduct) {
    isDiscontinued = true
  } else if (discontinuedColor) {
    isDiscontinued = true
    isColorDiscontinued = true
  }

  const handleNavChange = navActive => {
    const filteredNavData = navData.map((item, index) => ({
      ...item,
      isActive: index === navActive ? true : false,
    }))
    setNavData(filteredNavData)
    scroller.scrollTo(filteredNavData[navActive].elemId, {
      duration: 400,
      delay: 0,
      smooth: "easeOutSine",
      offset: isMobile ? -62 : -163,
    })
  }

  const handleScrollNav = navActive => {
    const filteredNavData = navData.map((item, index) => ({
      ...item,
      isActive: index === navActive ? true : false,
    }))
    setNavData(filteredNavData)
  }

  const handleQuantityChange = qty => {
    if (qty) {
      setCurrentQuantity(qty)
    }
  }

  const handleScroll = () => {
    scroller.scrollTo("buy-area", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
    })
  }

  const recommendedListClickHandler = title => {
    addDataLayer({
      title: title.toLowerCase(),
      productInfo: JSON.stringify(productInfo),
    })
  }

  const productAnalyticsData = {
    desc: props.desc,
    discountPrice: props.discountedPrice,
    unitPrice: props.price,
    category: props.productCategoryType,
    color: _get(
      props.colorsData?.find(item => item.id === props.sku),
      "label",
      ""
    ),
    sku: props.sku,
    name: props.name,
    quantity: currentQuantity,
    image: props.imagesData[0]?.url,
    stock: props.productOnStock,
    unitPrice: props.price,
    globalDiscount: props.globalDiscount || 0,
    discountPriceState:
      props.discountPercent > 0
        ? "percentOff|" + props.discountPercent
        : "regular price",
    businessUnitName: sanitizeTextForAnalytics(props.businessUnitName),
    customerFacingSKU: props?.customerFacingSKU || props?.sku || "n/a",
    productSaleable: props.productSaleable,
    availability: disableEcommerce
      ? "n/a"
      : props.productOnStock > 0
        ? "in stock"
        : "out of stock",
    superSku: props.superSku,
    productCollectionsName: sanitizeTextForAnalytics(
      props.productCollectionsName
    ),
    brandName: general?.siteName?.toLowerCase(),
    discountName: props.badgesProps?.badgeVal,
    productPartnerBuyNow: props.productPartnerBuyNow,
    defaultImageDataId: props.imagesData.length
      ? props.imagesData[0].label.split("|")[0]
      : null,
  }

  const { productCouponCode, productCoupondiscount } =
    getCurrentSkuCouponDiscounts({
      cart: props.cart,
      sku: productAnalyticsData.sku,
    })

  const productInfo = {
    category: (
      productAnalyticsData.category ||
      productAnalyticsData.businessUnitName ||
      "n/a"
    ).toLowerCase(),
    description: productAnalyticsData.desc || "n/a",
    frequency: "n/a",
    globalPromotionPrice: productAnalyticsData.globalDiscount
      ? Number(
        (
          productAnalyticsData.unitPrice - productAnalyticsData.globalDiscount
        ).toFixed(2)
      )
      : Number(productAnalyticsData.unitPrice),
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    priceState: productAnalyticsData.discountPriceState,
    productBasePrice: productAnalyticsData.unitPrice || "n/a",
    productCategory: (
      productAnalyticsData.category ||
      productAnalyticsData.businessUnitName ||
      "n/a"
    ).toLowerCase(),
    productColor: productAnalyticsData.color?.toLowerCase() || "n/a",
    productCoupondiscount: productCoupondiscount,
    productCouponCode: productCouponCode.join("|") || "n/a",
    productID: productAnalyticsData.customerFacingSKU || "n/a",
    productName: productAnalyticsData.name?.toLowerCase() || "n/a",
    productPartnerBuyNow: productAnalyticsData.productPartnerBuyNow,
    productRoom: (
      productAnalyticsData.businessUnitName || productAnalyticsData.category
    )?.toLowerCase(),
    productSalePrice: productAnalyticsData.discountPrice
      ? productAnalyticsData.discountPrice
      : productAnalyticsData.unitPrice,
    productSaleable: productAnalyticsData.productSaleable,
    productStatus: productAnalyticsData.availability,
    productSuperSku: productAnalyticsData.superSku ? true : false,
    productTileName: productAnalyticsData.name?.toLowerCase() || "n/a",
    quantity: productAnalyticsData.quantity || "n/a",
    defaultImageName: productAnalyticsData.image || "n/a",
    ratings: "n/a",
    numberOfReviews: "n/a",
    pdpType: pdpTypeFormat({
      businessUnitName: props.businessUnitName,
      ProductPriceSpiderIncluded_s: props.ProductPriceSpiderIncluded_s,
      discontinuedProductb: props.discontinuedProduct,
      ProductRequiredAccessoriesGroupsList:
        props.ProductRequiredAccessoriesGroupsList,
      superSku: props.superSku,
    }),
    productFindingMethod: "n/a",
    productCollectionsName: (
      productAnalyticsData.productCollectionsName ||
      productAnalyticsData.category ||
      "n/a"
    ).toLowerCase(),
    productBrand: productAnalyticsData.brandName,
    globalOffer: productAnalyticsData.discountName || "n/a",
    globalDiscount: productAnalyticsData.discountPrice
      ? productAnalyticsData.globalDiscount
      : 0,
    itemType: getCartItemType(
      productAnalyticsData.category,
      productAnalyticsData.businessUnitName
    ),
  }

  useEffect(() => {
    if (
      productInfo?.globalPromotionPrice !== null &&
      productInfo?.globalPromotionPrice !== undefined
    ) {
      setGlobalPromotionPrice(true)
    }
  }, [productInfo?.globalPromotionPrice])

  useEffect(() => {
    if (window.pageObj && props.loadShowEvent && isGlobalPromotionPrice) {
      const page = window?.adobeDataLayer?.[0]?.page || window?.pageObj || {}
      const category = page?.category || {}
      const pageType = page?.category?.pageType || ""
      const siteName = productAnalyticsData.brandName
      const pageInfo = page?.pageInfo || {}
      category["subCategory1"] =
        pageType + ":" + productAnalyticsData?.category?.toLowerCase()
      category["subCategoryName"] =
        pageType + ":" + productAnalyticsData?.category?.toLowerCase()
      category["subCategory2"] =
        pageType +
        ":" +
        productAnalyticsData?.category?.toLowerCase() +
        ":" +
        productAnalyticsData.customerFacingSKU
      category["subCategoryID"] = productAnalyticsData.customerFacingSKU
      category["room"] = productInfo?.productRoom?.toLowerCase()
      pageInfo["pageName"] =
        siteName +
        ":" +
        pageType +
        ":" +
        productAnalyticsData?.category?.toLowerCase() +
        ":" +
        productAnalyticsData.customerFacingSKU
      pageInfo["defaultImage"] = props.imagesData.length
        ? productAnalyticsData.defaultImageDataId || props.imagesData[0].url
        : "n/a"
      page.category = category
      if (!isShowAnalyticsEventLoaded()) {
        page.user = getUserAnalyticsObject()
        page.productInfo = productInfo
        if (
          (!page.user.gId || page.user.gId === "n/a") &&
          (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
        ) {
          page.pageInfo = pageInfo
          window.pageObj = page
          window.isShowAnalyticsEvent = true
        } else {
          window.adobeDataLayer.push({
            event: "cmp:show",
            pageInfo,
            productInfo,
            page,
          })
          delete window.pageObj
          dispatch(setProductInfo(productAnalyticsData.stringProductInfo))
        }
      }
    }
    return () => {
      dispatch(setProductInfo(null))
    }
  }, [props.loadShowEvent, productInfo])

  useEffect(() => {
    document.querySelector(".pdp-feature-image-top") !== null
      ? isDiscontinued
        ? (document.querySelector(".pdp-feature-image-top").style.display =
          "none")
        : (document.querySelector(".pdp-feature-image-top").style.display =
          "block")
      : ""
    const selectedColorInfo = props.colorsData?.find(item => item.id === props.sku);
    if (selectedColorInfo) {
      setImageColorDetails(`${selectedColorInfo["label"]} ${selectedColorInfo["finishName"] !== NO_FINISH_TYPE
        ? ` - ${selectedColorInfo["finishName"]}`
        : ""
        }`)
    }
  }, [props.sku])

  useEffect(() => {
    setTimeout(() => {
      props.discontinuedProduct &&
        document.querySelector(".pdp-main__replacement-suggestions") !== null
        ? (document.querySelector(
          ".pdp-main__replacement-suggestions"
        ).style.display = "block")
        : ""
      !props.discontinuedProduct &&
        discontinuedColor &&
        document.querySelector(".pdp-main__replacement-suggestions") !== null
        ? (document.querySelector(
          ".pdp-main__replacement-suggestions"
        ).style.display = "none")
        : "";
      (props.discontinuedProduct || discontinuedColor) &&
        document.getElementById("pdp-as-grout-template") !== null
        ? (document.getElementById("pdp-as-grout-template").style.display =
          "none")
        : "";
      (props.discontinuedProduct || discontinuedColor) &&
        document.getElementById("pdp-as-trim-template") !== null
        ? (document.getElementById("pdp-as-trim-template").style.display =
          "none")
        : "";
      (props.discontinuedProduct || discontinuedColor) &&
        document.getElementById("pdp-as-tile-template") !== null
        ? (document.getElementById("pdp-as-tile-template").style.display =
          "none")
        : "";
      (props.discontinuedProduct || discontinuedColor) &&
        document.getElementById("pdp-you-may-like-it") !== null
        ? (document.getElementById("pdp-you-may-like-it").style.display =
          "none")
        : ""
    }, 1500)

    const overviewBlock = document.querySelector(
      ".product-details .kf-react-container"
    )
    setStickyHeightCalc(Number(overviewBlock.offsetHeight)) //getting pdp overview block height and header height
  })

  const createMap = productImages => {
    const newProductImages = productImages?.map(item => ({ sku: item.split('|')[0], tag: item.split('|')[1] })) || [];
    return newProductImages;
  }

  return (
    <React.Fragment>
      {showGroutModal && (
        <PdpGroutChart
          authorData={props?.groutData}
          closePopup={() => openGroutChartModal()}
        />
      )}
      <Sticky
        topOffset={stickyHeightCalc}
        onFixedToggle={() => setSticky(!sticky)}
        className="product-details__sticky-wrapper"
      >
        {!isDiscontinued && sticky && (
          <StickyHeader
            {...props.stickyHeaderProps}
            currencySign={props.currencySign}
            price={
              props.discountedPrice > 0 ? props.discountedPrice : props.price
            }
            staticTexts={props.staticTexts}
            imgUrl={props.imagesData[0]?.url ?? ""}
            onAddToCart={cartItemProduct => props.onAddToCart(cartItemProduct)}
            handleNavChange={navActive => handleNavChange(navActive)}
            navData={navData}
            isDiscontinued={isDiscontinued}
            isColorDiscontinued={isColorDiscontinued}
            specialOrder={props.addToCartProps?.specialOrder}
            backOrder={props.addToCartProps?.backOrder}
            productOnStock={props.productOnStock}
            productStock={props.productOnStock}
            leadTimeRange={leadTimeRange}
            sku={props.sku}
            isComboSku={props.isComboSku}
            handleScroll={handleScroll}
            onAvailableColor={() => props.onAvailableColor()}
            handleScrollNav={handleScrollNav}
            productIsRetail={props.productIsRetail}
            templateType={templateType}
            ProductDescriptionDetail_s={
              props.productSelectYourStyle["ProductDescriptionDetail_s"]
            }
            priceTag={priceTag}
            analyticsProductInfo={JSON.stringify(productInfo)}
            isParts={props.isParts}
            disableEcommerce={disableEcommerce}
            replaceAddToCart={replaceAddToCart}
            replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
            replaceAddToCartCtaLink={replaceAddToCartCtaLink}
            linkNewTab={linkNewTab}
            productCategoryType={props.productCategoryType}
            general={general}
            accountName={accountName}
            swatchUrl={props?.swatchUrl}
            presetConfig={props?.presetConfig}
          />
        )}
      </Sticky>
      {props.toaster.show && (
        <div
          className={`product-details__toaster ${props.toaster.mobileOnly ? "--mobile" : ""
            } ${sticky ? "--sticky" : ""}`}
        >
          <Toaster message={props.toaster.message} />
        </div>
      )}
      <div className="product-details">
        <div className="container kf-react-container">
          {/* breadcrumbs */}
          
          <div className="header-section">
            <div className="product-details__breadcrumb">
              <section>
                <nav id="breadcrumb" aria-label="Breadcrumb">
                  <a
                    className="product-details__breadcrumb-link"
                    onClick={() =>
                      addDataLayer({
                        breadCrumbObj: {
                          breadCrumbTitle: `breadcrumb`,
                          breadCrumbPath:
                            `${props?.staticTexts?.home}`.toLowerCase(),
                        },
                        url:
                          (homePagePath.indexOf("http") === -1
                            ? window.location.origin
                            : "") + getShortenedUrl(homePagePath),
                      })
                    }
                    href={homePagePath}
                  >
                    {props.staticTexts.home}
                  </a>
                  <span aria-hidden="true">{" / "}</span>

                  <a
                    className="product-details__breadcrumb-link"
                    onClick={() =>
                      addDataLayer({
                        breadCrumbObj: {
                          breadCrumbTitle: `breadcrumb`,
                          breadCrumbPath: `${props?.staticTexts.home} > ${props?.productCategoryType
                            ? props?.productCategoryType
                            : props.staticTexts?.serviceParts
                            }`.toLowerCase(),
                        },
                        url:
                          (plpUrl.indexOf("http") === -1
                            ? window.location.origin
                            : "") + getShortenedUrl(plpUrl),
                      })
                    }
                    href={plpUrl}
                  >
                    {props.productCategoryType
                      ? props.productCategoryType
                      : props.staticTexts.serviceParts}
                  </a>
                </nav>
              </section>
            </div>
          </div>

          <div
            className="print-overview product-details__overview-block product-info"
            id="product-details__overview-block"
          >
            <div className="product-img-block product-details__image-gallery print-overview-left">
              <ProductGalleryView
                data={imagesData}
                productData={productAnalyticsData}
                staticTexts={props.staticTexts}
                productGalleryLabel={props.productGalleryLabel}
                enablePresets={enablePresets}
                presetConfig={props.presetConfig}
                swatchUrl={props.swatchUrl}
                templateType={templateType}
                sku={props.sku}
                pdpData={props.pdpData}
                accountName={accountName}
                showSaleBadge={props.showSaleBadge}
                imageColorDetails={imageColorDetails}
              />
            </div>
            <div
              className={
                templateType === SAMPLE
                  ? "product-info-block product-details__content-section print-overview-right sample-product"
                  : "product-info-block product-details__content-section print-overview-right"
              }
            >
              <ProductSummary
                pdpProductCustomerFacingName={pdpProductCustomerFacingName}
                productSummaryDetails={props.productSummaryDetails}
                price={props.price}
                discountedPrice={props.discountedPrice}
                currencySign={props.currencySign}
                persona={props.persona}
                orderSample={props.orderSample}
                isDiscontinued={isDiscontinued}
                staticTexts={props.staticTexts}
                authorData = {props.authorData}
                enableaddtocart={enableaddtocart}
                productData={productAnalyticsData}
                onAddToCart={props.onAddToCart}
                discountPercent={props.discountPercent}
                isType={props.isType}
                priceTag={priceTag}
                isSample={templateType === SAMPLE}
                templateType={templateType}
                analyticsProductInfo={JSON.stringify(productInfo)}
                cart={props.cart}
                disableEcommerce={disableEcommerce}
                productCategoryType={props.productCategoryType}
              />
              <div
                className={
                  isDiscontinued === true
                    ? "summaryWrapper summaryWrapper summaryWrapperDiscountinued select-style-block"
                    : "summaryWrapper select-style-block"
                }
              >
                <div className="summaryWrapper__top-block">
                  <div
                    className={
                      templateType === SAMPLE
                        ? "product-select-style__product-devider--none"
                        : "product-select-style__product-devider"
                    }
                  />
                </div>
                <div className="product-details__content-section summaryWrapper-right">
                  <div className="">
                    {enableselectstyle &&
                      (Object.keys(props.options).length > 0 ||
                        props.customLabel ||
                        props.productSelectYourStyle[
                        "ProductDescriptionDetail_s"
                        ]) && (
                        <ProductSelectYourStyle
                          {...props.productSelectYourStyle}
                          productImages={createMap(props.productImages)}
                          swatchUrl={props.swatchUrl}
                          productTitle={props.name}
                          ProductLocalCategory={props.ProductLocalCategory_s}
                          productCollection={props.productCollection}
                          i18n={props.staticTexts}
                          imageDetails={
                            props.options["ProductDetailImageURL_s"]
                          }
                          descriptionDetails={
                            props.options["ProductDescriptionDetail_s"]
                          }
                          brandName={general?.siteName?.toLowerCase()}
                          lwAppName={general?.lwAppName?.toLowerCase()}
                          selectOption={(val, facet, datalayerTitle) =>
                            props.selectOption(val, facet, datalayerTitle)
                          }
                          setSkuVariant={(sku, finish) =>
                            props.setSkuVariant(sku, finish)
                          }
                          colorDiscontinuedVarients={props.colorsData}
                          styleOptionsNotPresent={props?.styleOptionsNotPresent}
                          isDiscontinued={props?.discontinuedProduct}
                          customLabel={props.customLabel}
                          isColorDiscontinued={discontinuedColor}
                          analyticsProductInfo={JSON.stringify(productInfo)}
                          availableColors={props.availableColors}
                          authorData={props.authorData}
                          comboSkuDetails={props.comboSkuDetails}
                          productCategoryType={props.productCategoryType}
                          priceData={props?.priceData}
                          isCollapsedPDP={props?.isCollapsedPDP}
                          presetConfig={props.presetConfig}
                          accountName={accountName}
                        />
                      )}
                    {!props.price
                      ? ""
                      : enablecalculator &&
                      !isDiscontinued &&
                      showTrimCal && (
                        <PDPTrimCalculator
                          soldByBox={props.soldByBox}
                          soldByUom={props.soldByUom}
                          price={props.price}
                          priceByBox={
                            props.discountedPricePerBox > 0
                              ? props.discountedPricePerBox
                              : props.pricePerBox > 0 ? props.pricePerBox : 1
                          }
                          staticTexts={props.staticTexts}
                          templateType={templateType}
                          customLabel={props.customLabel}
                          analyticsProductInfo={JSON.stringify(productInfo)}
                          sku={props.sku}
                          setOnChangeStockAlert={setOnChangeStockAlert}
                          t={props.t}
                          cart={props.cart}
                          disableEcommerce={disableEcommerce}
                          RegionUOM={RegionUOM}
                          currencySign={props?.currencySign}
                          SKUInventoryStatus={props.productSummaryDetails?.["SKUAnnSacksNonStock_b"]}
                        />
                      )}

                    {templateType === "grout" && (
                      <div className="product-details__need-link-block">
                        <a
                          href="javascript:void(0)"
                          className="pdp-tile__need-link"
                          onClick={() => openGroutChartModal()}
                        >
                          {props && props?.customLabel?.grouttitle
                            ? props.customLabel.grouttitle
                            : props && props.staticTexts
                              ? props.staticTexts.productGroutNeed
                              : ""}
                        </a>
                      </div>
                    )}
                    <div className="row buy-area add-to-cart-main-block">
                      <AddToCart
                        {...props.addToCartProps}
                        key={props.sku}
                        t={props.t}
                        staticTexts={props.staticTexts}
                        onQtyChange={qty => handleQuantityChange(qty)}
                        onAddToCart={(cartItemProduct, cb) =>
                          props.onAddToCart(cartItemProduct, cb)
                        }
                        onAdd={() => props.onAddToCompare()}
                        onRemove={() => props.onRemoveFromCompare()}
                        checkCategory={() => props.checkProductCategory()}
                        comparedProductsCount={comparedProductsCount}
                        sku={props.sku}
                        isComboSku={props.isComboSku}
                        productCategory={props.ProductLocalCategory_s}
                        isEnable={props.isEnable}
                        isParts={props.isParts}
                        productOnStock={props.productOnStock}
                        isColorDiscontinued={isColorDiscontinued}
                        isDiscontinued={isDiscontinued}
                        specialOrder={props.addToCartProps?.specialOrder}
                        backOrder={props.addToCartProps?.backOrder}
                        productIsRetail={props.productIsRetail}
                        showToaster={props.showToaster}
                        onAvailableColor={() => props.onAvailableColor()}
                        productData={productAnalyticsData}
                        findStoreUrl={props.findStoreUrl}
                        promoTitle={props.promoTitle}
                        promoDescription={props.promoDescription}
                        enablePromo={props.enablePromo}
                        isFavorite={props.isFavorite}
                        price={
                          props.discountedPrice > 0
                            ? props.discountedPrice
                            : props.price
                        }
                        imagesData={props.imagesData}
                        templateType={templateType}
                        customLabel={props.customLabel}
                        favItem={props.favItem}
                        ctData={props.ctData}
                        updateRecalculateRoomInfo={(
                          lineItemId,
                          recalculateAdditionalInfo,
                          customQuantity,
                          cb
                        ) =>
                          props.updateRecalculateRoomInfo(
                            lineItemId,
                            recalculateAdditionalInfo,
                            customQuantity,
                            cb
                          )
                        }
                        analyticsProductInfo={JSON.stringify(productInfo)}
                        priceTag={priceTag}
                        ProductDescriptionDetail_s={
                          props.productSelectYourStyle[
                          "ProductDescriptionDetail_s"
                          ]
                        }
                        currencySign={props.currencySign}
                        productSummaryDetails={props.productSummaryDetails}
                        authorData={props.authorData}
                        SKUInventoryStatus={props.SKUInventory}
                        onChangeStockAlert={onChangeStockAlert}
                        config={config}
                        general={general}
                      />
                    </div>
                    {!isDiscontinued && (
                      <div className="recommended-list-details">
                        <div className="recommended-list-main-block">
                          {navData.find(
                            o => o.label === props.customLabel.recommendedOne
                          ) ? (
                            <div className="recommended-list-first-label">
                              <a
                                href={
                                  props.customLabel &&
                                    props.customLabel.recommendedOneId
                                    ? props.customLabel.recommendedOneId
                                    : "#"
                                }
                                className="recommended-list-first-link"
                                onClick={() =>
                                  recommendedListClickHandler(
                                    props.customLabel.recommendedOne
                                  )
                                }
                              >
                                {props.customLabel &&
                                  props.customLabel.recommendedOne
                                  ? props.customLabel.recommendedOne
                                  : ""}
                              </a>
                            </div>
                          ) : null}
                          {navData.find(
                            o => o.label === props.customLabel.recommendedTwo
                          ) ? (
                            <div className="recommended-list-second-label">
                              <a
                                href={
                                  props.customLabel &&
                                    props.customLabel.recommendedTwoId
                                    ? props.customLabel.recommendedTwoId
                                    : "#"
                                }
                                className="recommended-list-second-link"
                                onClick={() =>
                                  recommendedListClickHandler(
                                    props.customLabel.recommendedTwo
                                  )
                                }
                              >
                                {props.customLabel &&
                                  props.customLabel.recommendedTwo
                                  ? props.customLabel.recommendedTwo
                                  : ""}
                              </a>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProductDetailView
